<template>
  <custom-dialog :visible="visible" width="680px" class="project-select-tag-dialog" :title="model.title" v-on="$listeners" appendToBody>
    <div class="dialog-body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col>
            <el-form-item :label="$t('components_projectSelectTagDialog.xiang_mu_biao_qian')">
              <el-tag :key="index" v-for="(tag, index) in tags" closable :disable-transitions="false" @close="delTag(tag)" @click="editTag(tag)">
                {{ tag.tagName }}
              </el-tag>
              <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter.native="$event.target.blur" @blur="handleInputConfirm"></el-input>
              <el-button v-else class="button-new-tag" size="small" @click="addTag" type="primary">
                <i class="icon icon-add"></i>
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_close') }}</el-button>
    </div>
    <project-tag-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="updateTagsList"></project-tag-dialog>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';
import languageInjectMixins from '@/mixins/language_inject_mixins.js';
import projectTagDialog from '@/components/projectTagDialog.vue';

export default {
  mixins: [languageInjectMixins, dialogMixins],
  components: {
    projectTagDialog,
  },
  computed: {
    rules() {
      return {
        floorName: [
          {
            max: 30,
            message: this.$t('Common.com_rules_length_max', [30]),
          },
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
        ],
      };
    },
    // userInfo() {
    //   return this.$store.state.userInfo;
    // },
  },
  watch: {
    'model.data.orgId'() {
      if (this.model.data.orgId) {
        this.getTagsList();
      }
    },
  },
  data() {
    return {
      inputVisible: false,
      inputValue: '',
      form: {
        // 项目标签
        tagNames: '',
      },
      tags: [],
      locationInfo: {},
      dialogVisible: false,
      dialogModel: {},
    };
  },
  mounted: function () {
    this.initForm();
  },
  methods: {
    initForm() {
      // this.form.locationId = this.model.data.parentId; // 项目Id
      this.getTagsList();
      // if (this.model.type === 'edit') {
      //   this.form.floorId = this.model.data.id; // 项目Id
      //   this.getSiteInfo();
      // }
    },
    getTagsList() {
      this.$getJSON(apis.locationTagList, { orgId: this.model.data.orgId }).then((res) => {
        this.tags = res.data || [];
      });
    },
    updateTagsList() {
      this.getTagsList();
    },
    closeDialog() {
      this.$emit('success');
      this.visible = false;
    },
    // onConfirm() {
    //   if (this.model.type === 'add') {
    //     this.add();
    //   } else {
    //     this.edit();
    //   }
    // },
    addTag() {
      const title = this.$t('components_projectSelectTagDialog.xin_zeng_biao_qian');
      this.dialogModel.title = title;
      this.dialogModel.type = 'add';
      this.dialogModel.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName,
      };

      this.dialogVisible = true;
    },
    editTag(data) {
      const title = this.$t('components_projectSelectTagDialog.bian_ji_biao_qian');
      this.dialogModel.type = 'edit';
      this.dialogModel.title = title;
      this.dialogModel.data = {
        orgId: this.model.data.orgId,
        orgName: this.model.data.orgName,
        ...data,
      };
      this.dialogVisible = true;
    },
    delTag(row) {
      this.$showConfirm(this.$t('components_projectSelectTagDialog.nqdyscxzdbqm')).then(() => {
        this.$postJSON(`${apis.locationTagDelete}/${row.tagId}`).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_delete_success'),
          });
          this.updateTagsList();
        });
      });
    },
  },
};
</script>

<style lang="scss">
.project-select-tag-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .el-select {
    width: 100%;
  }
  .el-tag--small {
    height: 32px;
    line-height: 30px;
    margin-bottom: 10px;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .el-tag + .button-new-tag {
    margin-left: 10px;
  }
  .el-tag + .input-new-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
  }
  .detail-address {
    margin-top: 10px;
  }
}
</style>
